import { useEffect, useRef, useState } from 'react';
import { t } from '../i18n/idioma';
import type { DueloEstado } from '../world/types';
import { prazoNoCliente, relogio } from './dueloTempo';

interface Props {
  estado: DueloEstado;
  onFechar(): void;
}

export function DueloResultadoAviso({ estado, onFechar }: Props) {
  const marca = useRef({ chave: '', saque: 0 });
  const chave = `${estado.saqueAteMs}|${estado.agoraServidorMs}`;
  if (marca.current.chave !== chave)
    marca.current = { chave, saque: prazoNoCliente(estado.saqueAteMs, estado.agoraServidorMs) };

  const [agora, setAgora] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setAgora(Date.now()), 200);
    return () => window.clearInterval(id);
  }, []);

  const nome = estado.adversario;
  const falta = marca.current.saque - agora;
  const faltaAusente = prazoNoCliente(estado.ausenteAteMs, estado.agoraServidorMs) - agora;
  const loot = estado.modo === 'com_loot' && estado.vencedor === 'ele'
    && (estado.estado === 'saque' || estado.desfecho === 'vitoria');
  const saqueAberto = loot && falta > 0;

  const fechar = useRef(onFechar);
  fechar.current = onFechar;
  useEffect(() => {
    if (saqueAberto) return;
    const id = window.setTimeout(() => fechar.current(), loot ? 15_000 : 30_000);
    return () => window.clearTimeout(id);
  }, [saqueAberto, loot]);

  let texto: string;
  if (estado.desfecho === 'abandono')
    texto = estado.vencedor === 'voce'
      ? t('duelo.res.abandonoEle', { nome })
      : t('duelo.res.abandonoVoce', { nome });
  else if (estado.desfecho === 'cancelado' || estado.desfecho === 'interrompido')
    texto = t('duelo.res.interrompido');
  else if (saqueAberto)
    texto = t('duelo.res.perdeuLoot', {
      a: estado.placarVoce, b: estado.placarEle, nome, tempo: relogio(falta)
    });
  else if (loot)
    texto = t('duelo.res.saqueAcabou');
  else if (estado.estado === 'ausente')
    texto = t('duelo.ausenteAviso', { nome, tempo: relogio(faltaAusente) });
  else if (estado.vencedor === 'voce')
    texto = t('duelo.fim.textoVitoria');
  else if (estado.vencedor === 'ele')
    texto = t('duelo.fim.textoDerrota', { nome });
  else
    texto = t('duelo.res.interrompido');

  return (
    <div className="duelo-resultado" role="status">
      <p>{texto}</p>
      <button type="button" className="btn btn--ghost btn--tiny" onClick={onFechar}>{t('comum.fechar')}</button>
    </div>
  );
}
